import { mapActions } from 'vuex';
import bemMixin, { DEFAULT_OPTIONS } from 'framework/mixins/bem';
import cmsPluginMixin from 'framework/mixins/cms/cms-plugin';


export default {
    mixins: [
        bemMixin('gallery-item', { useProp: false }),
        cmsPluginMixin,
    ],
    props: {
        positionId: {
            type: Array,
        },
    },
    computed: {
        facet() {
            return this.content.facet || DEFAULT_OPTIONS.defaultFacet;
        },
        rootClasses() {
            return [
                this.bemFacet,
                this.bemIf(this.positionId === 0, 'is-first'),
            ];
        },
        preview() {
            return this.content.preview || {};
        },
        resource() {
            return {
                positionId: this.positionId,
                facet: this.content.facet,
                content: {
                    description: this.content.description,
                    ...this.content.resource,
                },
                type: `cmp-media-portal-item-${ this.content.facet }`,
            };
        },
    },
    methods: {
        ...mapActions(['openOverlay', 'addMediaItem', 'removeMediaItem']),
        onGalleryRequested(type) {
            this.$log.info('Gallery action requested:', type);

            this.openOverlay({
                facet: null,
                component: 'cmp-media-portal',
                props: {
                    initialItem: this.resource,
                },
            });
        },
    },
    mounted() {
        this.addMediaItem({
            item: this.resource,
        });
    },
    beforeDestroy() {
        this.removeMediaItem({
            item: this.resource,
        });
    },
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/mixins/gallery-item/index.js